import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'

import { TableHelper } from '../../../../tables'

import { MessagesTable } from '../../../../tables/message-table'

const AllMessages: React.FunctionComponent = observer(() => {
  const { messageStore } = useStores()
  const { setTriggerRefresh, triggerRefresh } = messageStore

  const [tableHelper] = useState(
    new TableHelper('list_all_messages', 'messages', 'messages', undefined, 'all'),
  )

  useEffect(() => {
    if (triggerRefresh) {
      tableHelper.load().then(() => setTriggerRefresh(false))
    }
  }, [triggerRefresh])

  return <MessagesTable forceLoading={triggerRefresh} tableHelper={tableHelper} />
})

export const AllMessagesTab = () => {
  return {
    name: 'All',
    path: `/activities/messages/all`,
    component: () => <AllMessages />,
  }
}
